<template>
  <x-dialog
    :dialogTitle="dialogTitle"
    :dialogState="isAddEditWidgetDialogOpen"
    width="50%"
    @toggleModal="closeAddEditDialog"
    content-class="customDialog"
    :actions="{
      show: true,
      secondaryButtonFunction: closeAddEditDialog,
      primaryButtonFunction: addOrEditWidget,
      primaryButtonShow: true,
      secondaryButtonText: 'Cancel',
      primaryButtonDisabled: isSaveDisabled,
      primaryButtonText: primaryBtnText
    }"
    :data-test-id="`${dataTestId}`"
  >
    <template slot="dialog_data" v-if="isAddEditWidgetDialogOpen">
      <v-row>
        <v-col>
          <label class="formInputLabel">Data type</label>
          <v-select
            v-if="dataReady"
            :items="showKPIList"
            filled
            solo
            flat
            background-color="#E5E5E5"
            append-icon="keyboard_arrow_down"
            color="#58e2c2"
            @change="changeDataType"
            disabled
            v-model="selectedDataType"
            item-value="id"
            item-text="text"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="time-span">
          <label class="formInputLabel">Time span</label>
          <v-btn-toggle
            v-model="selectedDataTypeTimeSpan"
            group
            tile
            elevation="0"
            color="#58e2c2"
            class="groupButtons"
            mandatory
          >
            <v-btn
              tile
              small
              v-for="item in timeSpanFrequency"
              :key="item.index"
              :value="item"
              :ripple="false"
              :class="{ hide: item === 'DAY' || item === 'WEEK' }"
              :data-test-id="`${dataTestId}__time-span-${item}`"
              >{{ item === 'ALL' ? 'ALL TIME' : item }}</v-btn
            >
          </v-btn-toggle>
        </v-col>
      </v-row>

      <v-row class="mx-0 mt-2">
        <x-dialog
          :dialogState="confirmRemoveWidget"
          :confirmDialog="true"
          @toggleModal="setDialogOpen(false)"
          :dialogTitle="'Confirm Delete?'"
          :actions="{
            show: true,
            secondaryButtonFunction: () => setDialogOpen(false),
            primaryButtonFunction: removeWidget,
            primaryButtonShow: true,
            secondaryButtonText: 'Cancel',
            primaryButtonText: 'Confirm'
          }"
        />

        <label class="formInputLabel">
          Graph type
          <small class="body-2" style="display:none;">
            (Not all kpis support all graph types. Unsupported graph types will
            be disabled.)
          </small>

          <span style="display:none;">{{ selectedGraphType }}</span>
        </label>
      </v-row>
      <v-row>
        <v-col
          :md="item.name === 'Icon' ? 5 : 4"
          v-for="item in widgetListData"
          :key="item.index"
          :class="{
            hide: !item.isSelected || !(isVisible(item) && selectedWidgetInfo)
          }"
        >
          <v-card
            tile
            v-if="isVisible(item) && selectedWidgetInfo"
            elevation="0"
            class="graphTypeCard"
            justify="center"
            :class="{ disabled: item.isDisabled, active: item.isSelected }"
            @click.native="selectGraphType(item)"
            disabled
          >
            <v-card-text class="pa-2">
              <v-row no-gutters align="center">
                <v-col v-if="item.name === 'Icon'" cols="8">
                  <p class="mb-0">{{ selectedKpi.label }}</p>
                </v-col>
                <v-col :cols="item.name === 'Icon' ? 4 : 12">
                  <v-img
                    v-if="!darkTheme"
                    :src="item.imgSrc"
                    height="100"
                    contain
                    aspect-ratio="1"
                    :title="getTooltip(item.isDisabled)"
                  ></v-img>
                  <v-img
                    v-else
                    :src="item.imgSrcDark"
                    height="100"
                    contain
                    aspect-ratio="1"
                  ></v-img>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-title class="body-1 graphTypeCardTitle pa-2">
              {{ item.description }}
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>

      <!-- START GRAPH SIZE -->
      <v-row class="mt-2">
        <v-col>
          <label class="formInputLabel">
            Graph size
            <!-- - {{ graphSize[selectedGraphSize] }} -->
          </label>
          <v-btn-toggle
            v-model="selectedGraphSize"
            elevation="0"
            group
            color="#58e2c2"
            class="groupButtons"
            outlined
            mandatory
          >
            <v-btn
              tile
              small
              v-for="item in graphSize"
              :disabled="isSizeButtonDisabled()"
              :key="item.index"
              :ripple="false"
              >{{ item }}</v-btn
            >
          </v-btn-toggle>
        </v-col>
      </v-row>
      <!-- END GRAPH SIZE -->
    </template>

    <!-- </v-card> -->
  </x-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import findIndex from 'lodash/findIndex';
import KPISlugsForLegacyOrg from '@/components/Organisations/Widgets/kpis';
export default {
  data() {
    return {
      confirmRemoveWidget: false,
      newRowWidgetRatio: {
        LARGE: 'SMALL',
        SMALL: 'LARGE',
        MEDIUM: 'MEDIUM'
      },
      isSaveDisabled: true,
      widgetMode: null,
      // this is selected widget info from store. will be populated in watch
      selectedWidgetInfo: null,
      dataReady: false,
      selectedKpi: null,
      selectedDataType: null,
      selectedDataTypeTimeSpan: 0,
      selectedGraphType: 0,
      selectedGraphSize: null,
      widgetListData: [],
      dialogTitle: 'Create a widget',
      primaryBtnText: 'Save',
      timeSpanFrequency: ['DAY', 'WEEK', 'MONTH', 'YEAR', 'DECADE', 'ALL'],
      graphSize: ['SMALL', 'MEDIUM', 'LARGE'],
      dataType: [], // list of kpis

      // old and not needed
      disabledItems: [],
      darkTheme: null,
      dataTestId:'edit-widget-dialog'
    };
  },
  created: function() {
    this.maxColsInFirstRow = 4;
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  computed: {
    ...mapState({
      addEditDialogState: state => state.dashboard.isAddEditWidgetDialogOpen
    }),
    // !IMPORTANT: vuex computed properties should always have a getter and setter
    isAddEditWidgetDialogOpen: {
      get() {
        return this.addEditDialogState;
      },
      set(value) {
        this.toggleAddEditModal(value);
      }
    },
    showTertiaryButton() {
      return (
        this.isAddEditWidgetDialogOpen &&
        this.selectedWidgetInfo &&
        this.selectedWidgetInfo.kpiSlug !== 'empty_slug' &&
        this.selectedGraphType !== 'Icon'
      );
    },
    showKPIList() {
      let dataTypeList = this.dataType;
      //Forming subscribed org KPI's list,
      //By filtering kpi's meant for leagcy orgs
      if (!this.isCurrentOrgLegacy) {
        dataTypeList = this.dataType.filter(
          dataType => !KPISlugsForLegacyOrg.includes(dataType?.id)
        );
      }
      return dataTypeList;
    }
  },
  watch: {
    // eslint-disable-next-line
    isAddEditWidgetDialogOpen(newValue, oldValue) {
      if (newValue) {
        document.body.classList.add('no-scroll');
        this.setWidgetUpdateHappened(false);
        this.loadDataOnDialogOpen();

        this.selectedWidgetInfo = this.getSelectedwidgetForEdit();

        if (
          this.selectedWidgetInfo.kpiSlug === 'empty_slug' &&
          this.selectedWidgetInfo.id === null
        ) {
          this.widgetMode = 'add';
          this.dialogTitle = 'Create a widget';
          this.primaryBtnText = 'Save';
        } else {
          this.widgetMode = 'edit';
          if (this.selectedWidgetInfo.kpiSlug === 'empty_slug') {
            this.dialogTitle = 'Create a widget';
          } else {
            this.dialogTitle = 'Edit widget';
          }
          this.primaryBtnText = 'Save';
          this.setSelectedItems();
          this.setSelectedKPI();
          this.updateWidgetList();
        }
        this.dataReady = true;
        this.toggleSaveButton();
      } else {
        document.body.classList.remove('no-scroll');
        this.dataReady = false;
        this.dataType = [];
        this.selectedDataType = null;
        this.selectedDataTypeTimeSpan = null;
        this.selectedGraphType = null;
        this.selectedGraphSize = 0;
      }
    }
  },
  methods: {
    escapeKeyListener: function(evt) {
      if (
        evt.keyCode === this.escapeKeyCode &&
        this.isAddEditWidgetDialogOpen
      ) {
        this.closeAddEditDialog();
      }
    },
    ...mapGetters('dashboard', [
      'getKpiDetails',
      'toggleAddEditWidgetDialogOpen',
      'getSelectedwidgetForEdit',
      'getWidgetList'
    ]),
    ...mapMutations('dashboard', [
      'toggleAddEditModal',
      'setWidgetUpdateHappened',
      'setWidgetList',
      'setSelectedForEdit'
    ]),
    getTooltip(disabled) {
      return disabled
        ? 'Disabled: Not all graph types support all data types.'
        : '';
    },
    setDialogOpen(val) {
      this.confirmRemoveWidget = val;
    },
    confirmDelete() {
      this.confirmRemoveWidget = true;
    },
    isVisible(item) {
      if (
        this.selectedWidgetInfo.row === 1 ||
        // eslint-disable-next-line
        this.selectedWidgetInfo.row === 2
      ) {
        return item.name === 'Icon';
      } else {
        return item.name !== 'Icon';
      }
    },
    toggleSaveButton() {
      if (
        this.selectedDataType === null ||
        this.selectedDataTypeTimeSpan === null ||
        this.selectedGraphType === null ||
        this.selectedGraphType === undefined ||
        this.selectedGraphType === 0 ||
        this.selectedGraphSize === null
      ) {
        this.isSaveDisabled = true;
      } else {
        this.isSaveDisabled = false;
      }
    },
    async removeWidget() {
      this.confirmRemoveWidget = false;
      let allWidgetList = this.getWidgetList();
      // send empty call
      await this.axios.patch(
        this.getServiceURL('baseUrlForConfig') +
          '/dashboard/widget/empty/widget/' +
          this.selectedWidgetInfo.id
      );
      this.selectedWidgetInfo.kpiSlug = 'empty_slug';

      // we dont want to delete the entire first row
      if (this.selectedWidgetInfo.row === 1) {
        this.setWidgetUpdateHappened(true);
        this.closeAddEditDialog();
        return false;
      }

      // if this row has kpiId 0 for all cards, delete it all
      // find num cards in this row
      const sameRowCards = allWidgetList.filter(
        element => element.row === this.selectedWidgetInfo.row
      );
      // find kpiId = 0 cards in row
      const zeroKpiCards = sameRowCards.filter(
        element => element.kpiSlug === 'empty_slug'
      );

      // if above both equal - row is empty - delete it
      if (sameRowCards.length === zeroKpiCards.length) {
        // need to delete the row
        zeroKpiCards.forEach(card => {
          // send delete call
          this.axios.delete(
            this.getServiceURL('baseUrlForConfig') +
              '/dashboard/widget/' +
              card.id
          );
          // row deleted now delete all elements of this row from widgetlist array
          const index = findIndex(
            allWidgetList,
            element => element.id === card.id
          );
          allWidgetList.splice(index, 1);
        });
      }

      this.setWidgetUpdateHappened(true);
      this.closeAddEditDialog();
    },
    getMaxRowNumber() {
      let maxRowNum = 0;
      let allWidgetList = this.getWidgetList();
      allWidgetList.forEach(element => {
        maxRowNum = element.row > maxRowNum ? element.row : maxRowNum;
      });
      return maxRowNum;
    },
    addOrEditWidget() {
      // !note: when a widget in new row is added, another widget needs to be added which will be 12 - that widget
      // ! also need to be added to widgetList array
      // this is from store
      let allWidgetList = this.getWidgetList();
      // get name of selected widget
      let x = this.dataType.find(item => item.id === this.selectedDataType);
      this.selectedWidgetInfo.kpiIdName = x.text;
      // set the widget isNew to true
      this.selectedWidgetInfo.isNew = true;
      this.selectedWidgetInfo.isStorageTypeData = this.selectedKpi?.dataKPI;
      this.selectedWidgetInfo.kpiSlug = this.selectedDataType;
      this.selectedWidgetInfo.size = this.graphSize[this.selectedGraphSize];
      this.selectedWidgetInfo.timeUnit = this.selectedDataTypeTimeSpan;
      this.selectedWidgetInfo.widgetGraphName = this.selectedGraphType;
      // widgetListData
      let selectedGraphType = this.widgetListData.find(
        item => item.name === this.selectedGraphType
      );
      this.selectedWidgetInfo.widgetTypeId = selectedGraphType.id;

      if (this.widgetMode === 'add') {
        // this.selectedWidgetInfo.id = 632;
        this.selectedWidgetInfo.row = this.getMaxRowNumber() + 1;
        this.selectedWidgetInfo.position = 1;
        allWidgetList.push(this.selectedWidgetInfo);
      }

      this.startUpdateWidget();
    },
    async startUpdateWidget() {
      const requestObj = {
        kpiSlug: this.selectedWidgetInfo.kpiSlug,
        position: this.selectedWidgetInfo.position,
        row: this.selectedWidgetInfo.row,
        size: this.selectedWidgetInfo.size,
        timeUnit: this.selectedWidgetInfo.timeUnit,
        widgetTypeId: this.selectedWidgetInfo.widgetTypeId
      };

      this.closeAddEditDialog();
      if (this.widgetMode === 'add') {
        let userData = JSON.parse(localStorage.getItem('userData'));
        let userName = userData.preferred_username;
        await this.axios.post(
          this.getServiceURL('baseUrlForConfig') +
            '/dashboard/widget/' +
            userName +
            '/' +
            this.currentlySelectedOrgId,
          requestObj
        );

        let emptyWidgetURL =
          this.getServiceURL('baseUrlForConfig') +
          '/dashboard/widget/empty/widget/' +
          userName +
          '/' +
          this.currentlySelectedOrgId +
          '?position=' +
          (requestObj.position + 1) +
          '&row=' +
          requestObj.row +
          '&size=' +
          this.newRowWidgetRatio[requestObj.size];
        await this.axios.post(emptyWidgetURL);

        // create another empty widget in new row
        // this is from store
        let allWidgetList = this.getWidgetList();
        let widgetConfig = await this.axios.get(
          this.getServiceURL('baseUrlForConfig') +
            '/config/' +
            userName +
            '/' +
            this.currentlySelectedOrgId
        );
        let widgetConfigBody = widgetConfig.data.body.widgets;
        let newlyAdded = widgetConfigBody.find(
          element =>
            element.row === this.selectedWidgetInfo.row &&
            element.position === this.selectedWidgetInfo.position
        );
        this.selectedWidgetInfo.id = newlyAdded.id;
        this.selectedWidgetInfo.isNew = true;
        this.setSelectedForEdit(this.selectedWidgetInfo);

        // create another empty widget in new row
        let emptyWidget = {
          id: null,
          kpiId: 0,
          kpiSlug: 'empty_slug',
          kpiIdName: requestObj.kpiIdName,
          position: requestObj.position + 1,
          row: requestObj.row,
          size: this.newRowWidgetRatio[this.selectedWidgetInfo.size],
          timeUnit: 0,
          widgetGraphName: requestObj.widgetGraphName,
          widgetTypeId: requestObj.widgetTypeId
        };
        let newlyAddedEmpty = widgetConfigBody.find(
          element =>
            element.row === emptyWidget.row &&
            element.position === emptyWidget.position
        );
        emptyWidget.id = newlyAddedEmpty.id;

        allWidgetList.push(emptyWidget);

        // trigger changes back to the page
        this.setWidgetUpdateHappened(true);
      }
      if (this.widgetMode === 'edit') {
        this.axios.put(
          this.getServiceURL('baseUrlForConfig') +
            '/dashboard/widget/' +
            this.selectedWidgetInfo.id,
          requestObj
        );
        // trigger changes back to the page
        this.setWidgetUpdateHappened(true);
      }
    },
    selectGraphType(item) {
      // dont allow pie selection if it is disabled
      if (item.isDisabled) {
        return false;
      }
      this.selectedGraphType = item.name;
      this.toggleSaveButton();
      this.updateWidgetList();
    },
    closeAddEditDialog() {
      // mutation
      this.toggleAddEditModal(false);
      this.disabledItems = [];
    },
    isSizeButtonDisabled() {
      return this.selectedWidgetInfo &&
        this.selectedWidgetInfo.kpiSlug === 'empty_slug' &&
        this.selectedWidgetInfo.id === null
        ? false
        : true;
    },
    loadDataOnDialogOpen() {
      let widgetListData = JSON.parse(localStorage.getItem('widgetList'));

      widgetListData.forEach(function(item) {
        switch (item.description) {
          case 'Pie chart':
            item.imgSrc = require('@/assets/images/theme--light/pie-chart-light.svg');
            item.imgSrcDark = require('@/assets/images/theme--dark/pie-chart-dark.svg');
            break;
          case 'Bar chart':
            item.imgSrc = require('@/assets/images/theme--light/bar-chart-light.svg');
            item.imgSrcDark = require('@/assets/images/theme--dark/bar-chart-dark.svg');
            break;
          case 'Area graph':
            item.imgSrc = require('@/assets/images/theme--light/area-graph-light.svg');
            item.imgSrcDark = require('@/assets/images/theme--dark/area-graph-dark.svg');
            break;
          case 'Single stat with icon':
            item.imgSrc = require('@/assets/images/theme--light/single-stat-light.svg');
            item.imgSrcDark = require('@/assets/images/theme--dark/single-stat-dark.svg');
            break;
          case 'Line graph':
            item.imgSrc = require('@/assets/images/theme--light/line-graph-light.svg');
            item.imgSrcDark = require('@/assets/images/theme--dark/line-graph-dark.svg');
            break;
        }
      });
      this.widgetListData = widgetListData;
      const kpiData = JSON.parse(localStorage.getItem('kpis'));
      kpiData.forEach((item, index) => {
        this.dataType.push({
          text: item.label,
          id: item.slug,
          disabled: false,
          sl: index
        });
      });
    },
    setSelectedKPI() {
      const kpiDetails = this.getKpiDetails();
      // this will need to be set on dropdown change as well
      const selectedKpi = kpiDetails.find(
        kpi => kpi.slug === this.selectedDataType
      );
      if (selectedKpi !== undefined) {
        this.selectedKpi = selectedKpi;
      } else {
        this.selectedKpi = null;
      }
    },
    setSelectedItems() {
      if (this.selectedWidgetInfo === undefined) {
        return false;
      }
      if (this.selectedWidgetInfo.kpiSlug === 'empty_slug') {
        this.selectedDataType = null;
        this.selectedDataTypeTimeSpan = null;
        this.selectedGraphType = null;
        this.selectedGraphSize = null;
      }
      this.selectedDataType = this.selectedWidgetInfo.kpiSlug || null;
      this.selectedDataTypeTimeSpan = this.selectedWidgetInfo.timeUnit;
      this.selectedGraphType = this.selectedWidgetInfo.widgetGraphName;
      this.selectedGraphSize = this.graphSize.indexOf(
        this.selectedWidgetInfo.size
      );
    },
    changeDataType() {
      // disable pie/icon based on selection
      const kpiDetails = this.getKpiDetails();
      // this will need to be set on dropdown change as well
      const selectedKpi = kpiDetails.find(
        kpi => kpi.slug === this.selectedDataType
      );
      this.selectedKpi = selectedKpi;

      // if this kpi does not support pie, set selected graphtype to null
      if (
        this.selectedGraphType === 'Pie' &&
        this.selectedKpi.dataConstraintType[0] === 'NOT_PIE_TYPE'
      ) {
        this.selectedGraphType = null;
      }
      // if this is row 1 and kpi with more than 3 items is selected, disable icon
      if (
        this.selectedWidgetInfo.row === 1 &&
        this.selectedKpi.columns.length === this.maxColsInFirstRow
      ) {
        this.selectedGraphType = null;
      }

      this.toggleSaveButton();
      this.updateWidgetList();
    },
    updateWidgetList() {
      if (!this.selectedKpi) {
        return false;
      }
      this.widgetListData.forEach(item => {
        if (
          (this.selectedKpi.dataConstraintType[0] === 'NOT_PIE_TYPE' &&
            item.name === 'Pie') ||
          (this.selectedWidgetInfo.row === 1 &&
            this.selectedKpi.columns.length === this.maxColsInFirstRow)
        ) {
          item.isDisabled = true;
        } else {
          item.isDisabled = false;
        }

        item.isSelected = this.selectedGraphType === item.name;
      });
      if (this.selectedWidgetInfo.row === 1) {
        this.selectedGraphType = 'Icon';
      }
    }
  },
  mounted() {},
  beforeDestroy() {}
};
</script>

<style scoped>
.v-icon.material-icons.theme--light {
  color: #58e2c2;
}
.v-btn-toggle .v-btn.v-btn--active {
  background-color: #58e2c2 !important;
  color: #fff;
}

.groupButtons .v-btn.v-btn--active {
  background-color: #58e2c2 !important;
  color: #fff;
}
.theme--light.v-btn.v-btn--active.v-btn--disabled[data-v-5fe492cd]:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #58e2c2 !important;
  color: #fff !important;
}

.v-btn.v-btn.btn-fixed-width {
  min-width: 150px !important;
}
</style>
